// src/app/core/services/navigation-tracker.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationTrackerService {
  private excludedRoutes = ['/login', '/register', '/recuperar-password', '/account', '/account/profile', '/account/people', '/account/tickets'];

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;

        const isExcluded = this.excludedRoutes.some(route => url.startsWith(route));
        if (!isExcluded) {
          localStorage.setItem('lastVisitedUrl', url);
        }
      }
    });
  }
}
